import { ITranslationProps } from '@lib/i18n/translation';
import * as React from 'react';
import { INativeWindow } from 'types';
import CheckBox from './CheckBox';
import './Menu.css';

export interface IMenuProps {
  push: boolean;
  show: boolean;
  onASite: boolean;
  i18n: ITranslationProps;
  mail: string;
  token: string;
  onSiteClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  onPushClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  onSignoutClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  onHelpClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  onChangePasswordClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  onCloseClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  onViewAlarmList?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onViewLogEventList?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onViewUserList?: (event: React.MouseEvent<HTMLDivElement>) => void;
}


interface IMenuState {
  nbAbusiveClick: number;
  destroy: boolean;
}

// declare var Waves: any;

class Menu extends React.Component<IMenuProps, IMenuState> {

  public constructor(props: IMenuProps) {
    super(props);
    this.state = {
      destroy: false, nbAbusiveClick: 0
    };
  }

  public componentDidMount() {
    // Waves.attach('div.buttonDown', 'waves-light');
    // Waves.attach('div.buttonUp', 'waves-light');

  }

  public dummyClick(event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation();
  }

  /**
   * Naviagte to recipient list
   * @param event 
   */
  public goToRecipientList(event: React.MouseEvent<HTMLDivElement>) {
    window.location.hash = 'recipientList'
  }


  /**
   * Naviagte to system information
   * @param event 
   */
  public goToStatus(event: React.MouseEvent<HTMLDivElement>) {
    window.location.hash = 'status'
  }

  /**
   * Navigate to sms piloting
   * @param {React.MouseEvent<HTMLDivElement>} event
   * @memberof Menu
   */
  public goToSms(event: React.MouseEvent<HTMLDivElement>) {
    window.location.hash = 'sms'
  }

  public onCloseClick(event: React.MouseEvent<HTMLDivElement>) {
    // Detect abusive click
    if (!this.props.show) {
      this.setState({ nbAbusiveClick: this.state.nbAbusiveClick + 1 }, () => {
        if (this.state.nbAbusiveClick > 3) {
          document.location.href = 'index.html';
        }
      });
      return;
    }

    // Here we are in a buggy ios situation, let's reloade the app
    // document.location.pathname = '/';
    // return;
    this.props.onCloseClick(event);
  }

  public render() {
    const { onASite, show } = this.props;
    const i18n = this.props.i18n.i18n.Menu;
    // label, value, onUpClick, onDownClick,

    if (this.state.destroy) {
      return null;
    }

    return (

      <div className={'menuContainer hidden' + (show ? ' open' : '')} onClick={this.onCloseClick.bind(this, null)}>
        <div className={'menuTopPart hidden' + (show ? ' open' : '')} onClick={this.onCloseClick.bind(this, null)} >
          <div className="menuAvatar" />
          <span>{this.props.mail}</span>
        </div >
        <div className={'menuBottomPart hidden' + (show ? ' open' : '')} onClick={this.onCloseClick.bind(this, null)} >
          {(window as INativeWindow).FirebasePlugin.isFake !== true && this.props.token !== undefined && this.props.token !== '' &&
            <div>
              <CheckBox
                checked={this.props.push} label={i18n.push} onClick={this.props.onPushClick.bind(this, this.state)} />
            </div>
          }
          <div onClick={this.props.onSiteClick} className="menuItem site"><span>{i18n.site}</span></div>
          {onASite &&
            <div onClick={this.goToRecipientList} className="menuItem recipient"><span>{i18n.recipient}</span></div>
          }
          {onASite &&
            <div onClick={this.props.onViewAlarmList} className="menuItem alarm"><span>{i18n.alarm}</span></div>
          }
          {onASite &&
            <div onClick={this.props.onViewLogEventList} className="menuItem logevent"><span>{i18n.logEvent}</span></div>
          }
          {onASite &&
            <div onClick={this.goToStatus} className="menuItem info"><span>{i18n.status}</span></div>
          }
          {onASite &&
            <div onClick={this.props.onViewUserList} className="menuItem user"><span>{i18n.habilitedUsers}</span></div>
          }
          <div onClick={this.goToSms} className="menuItem sms"><span>{i18n.sms}</span></div>
          <div onClick={this.props.onChangePasswordClick} className="menuItem password"><span>{i18n.password}</span></div>
          <div onClick={this.props.onHelpClick} className="menuItem help"><span>{i18n.help}</span></div>
          <div onClick={this.props.onSignoutClick} className="menuItem signout"><span>{i18n.signout}</span></div>
        </div >
        <div className={'menuOverlay hidden' + (show ? ' open' : '')} />
      </div >

    );
  }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Menu.tsx